// extracted by mini-css-extract-plugin
module.exports = {"editorWrapper":"styles_editorWrapper__1d01a","metaToolbar":"styles_metaToolbar__2KXe9","spacer":"styles_spacer__1npFo","label":"styles_label__1DUHM","value":"styles_value__fJ_iO"};